import closeIcon from 'assets/icons/close.svg';
import IphoneX from 'assets/iphone_x.svg';
import IphoneXMobile from 'assets/iphone_x_mobile.svg';
import React from 'react';
import { PrimaryButton } from '../../../common/buttons/PrimaryButton/PrimaryButton';
import './DownloadAppHeader.pcss';
import { DownloadAppHeaderViewProps } from './types';

export const DownloadAppHeaderView = (props: DownloadAppHeaderViewProps) => {
  const { isMobile, isHidden, hideBlock, link, onClick, primaryButtonColor } =
    props;

  return (
    <div className="live-chat--messages__top-header" hidden={isHidden}>
      {isMobile && <button className="close-button" onClick={hideBlock} />}
      <img
        alt="IPhone X Frame"
        className="live-chat--messages__top-header-iphone"
        src={isMobile ? IphoneXMobile : IphoneX}
      />
      <div className="live-chat--messages__top-header-content">
        <div className="live-chat--messages__top-header-text">
          {isMobile && (
            <>
              {'Have you heard about our mobile app?'}
              <br />
            </>
          )}
          <b>
            {
              'Install our mobile app to respond to customers straight from your phone'
            }
          </b>
        </div>
        <div className="live-chat--messages__top-header-button-wrapper">
          {isMobile ? (
            <a
              className="live-chat--messages__top-header-link"
              href={link}
              target={'_blank'}
            >
              {'Download App'}
            </a>
          ) : (
            <PrimaryButton
              className="live-chat--messages__top-header-button"
              color={primaryButtonColor}
              onClick={onClick}
            >
              Download&nbsp;App
            </PrimaryButton>
          )}
        </div>
        {!isMobile && (
          <div className="download-app-header__close-wrapper">
            <span
              className="download-app-header__close-icon"
              onClick={hideBlock}
            >
              <img src={closeIcon} alt="close mobile download" />
            </span>
          </div>
        )}
      </div>
    </div>
  );
};
